import {
  Form,
  Input,
  FormFeedback,
  Button,
  Label,
  FormGroup,
} from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { resetPassword } from "../../api/auth";
import ResultHandler from "../../components/ResultHandler";
import logo from "../../assets/images/QN-logo-mini.png";
import useCustomValidation from "../dashboard/validationSchema";
import { useResponse } from "../../hooks/useResponse";
import toast from "react-hot-toast";

const ResetPassword = () => {
  const { resetPasswordSchema } = useCustomValidation();
  const history = useHistory();

  const { setData, loading, error } = useResponse(resetPassword, () => {
    toast.success("Your password changed successfully");
    history.push("/login");
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      pin: "",
      newPassword: "",
      newPasswordConfirmation: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: (values) => {
      const email = localStorage.getItem("email") || "";
      setData({ type: "add", data: { ...values, email } });
    },
  });

  return (
    <div style={{ minHeight: "100vh" }}>
      <div
        className="text-start w-100 p-3"
        style={{ cursor: "pointer" }}
        onClick={() => history.goBack()}
      >
        <i class="bx bx-arrow-back font-size-16 fw-bold"></i>
      </div>

      <div className="d-flex justify-content-center align-items-center flex-column">
        <div
          className="d-flex justify-content-center align-items-center flex-column p-3"
          style={{ width: "500px", maxWidth: "100%" }}
        >
          <div style={{ height: "80px", width: "80px" }}>
            <img src={logo} alt="logo" className="w-100 h-100" />
          </div>

          <div className="w-100 mt-4">
            <Form className="form-horizontal" onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <h5
                  style={{
                    fontSize: "17px",
                    fontWeight: "600",
                    borderLeft: "3px solid",
                    paddingLeft: "10px",
                    marginBottom: "16px",
                  }}
                >
                  Reset Password
                </h5>

                <FormGroup className="mt-4 mb-3">
                  <Label>Recovary code</Label>
                  <Input
                    name="pin"
                    className="form-control"
                    type="text"
                    placeholder="Enter the code we sent to your email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.pin || ""}
                    invalid={
                      formik.touched.pin && formik.errors.pin ? true : false
                    }
                  />
                  {formik.touched.pin && formik.errors.pin ? (
                    <FormFeedback type="invalid">
                      {formik.errors.pin}
                    </FormFeedback>
                  ) : null}
                </FormGroup>

                <FormGroup className="mb-3">
                  <Label>New password</Label>
                  <Input
                    name="newPassword"
                    className="form-control"
                    type="password"
                    placeholder="New Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.newPassword || ""}
                    invalid={
                      formik.touched.newPassword && formik.errors.newPassword
                        ? true
                        : false
                    }
                  />
                  {formik.touched.newPassword && formik.errors.newPassword ? (
                    <FormFeedback type="invalid">
                      {formik.errors.newPassword}
                    </FormFeedback>
                  ) : null}
                </FormGroup>

                <FormGroup className="mb-4">
                  <Label>Confirm password</Label>
                  <Input
                    name="newPasswordConfirmation"
                    className="form-control"
                    type="password"
                    placeholder="Confirm Password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.newPasswordConfirmation || ""}
                    invalid={
                      formik.touched.newPasswordConfirmation &&
                      formik.errors.newPasswordConfirmation
                        ? true
                        : false
                    }
                  />
                  {formik.touched.newPasswordConfirmation &&
                  formik.errors.newPasswordConfirmation ? (
                    <FormFeedback type="invalid">
                      {formik.errors.newPasswordConfirmation}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </div>

              <ResultHandler error={error} />

              <Button
                color="primary"
                type="submit"
                disabled={loading}
                className="w-100 fw-bold"
              >
                {loading ? "Loading..." : "Confirm"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
